import React from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import LogoOne from '../../../assets/images/logo.png';
import LoginBanner from '../../../assets/images/login_banner.png';
import ChangePasswordForm from './ChangePasswordForm';

// Standalone page (no MainLayout / no navbar) — mirrors the yard_management_fe
// ResetPassword.js layout: form card on the left (col-4), banner image on the right.
// Routed directly in Layout.js outside <MainLayout>.
const ChangePasswordPage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Container fluid>
        <Row>
          {/* ── Left column: form card ── */}
          <Col style={{ position: 'relative' }} className='p-0 col-4 form-login'>
            <div className='login-wrap'>
              <Card className='h-100 pt-4 pb-5 p-4'>
                <img src={LogoOne} className='logoWidth pb-5' alt='ODeX logo' />
                <Card.Header className='cardHeader textLowerCase'>
                  {t('resource_2:changePassword')}
                </Card.Header>
                <Card.Body className='p-2 bodyHeightReset'>
                  <ChangePasswordForm />
                </Card.Body>
                <fieldset>
                  <legend>{t('resource_2:passwordPolicy')}</legend>
                  <p>{t('resource_message:passwordLength')}</p>
                  <p>{t('resource_message:passwordShouldContainUpparAndLowerCase')}</p>
                  <p>{t('resource_message:passwordShouldContainNo')}</p>
                </fieldset>
                <div className='col-12 fs--1 copyWriteText'>
                  Copyright © EA Technologies 2025. All rights reserved
                </div>
              </Card>
            </div>
          </Col>

          {/* ── Right column: banner image ── */}
          <Col className='p-0'>
            <div style={{ position: 'relative' }} className='image-container'>
              <Image
                src={LoginBanner}
                fluid
                style={{ height: '100vh', width: '100%', objectFit: 'cover' }}
                alt='ODeX banner'
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ChangePasswordPage;
